import { useEffect, useState } from "react";
import { Col, Row } from "antd";
import { useBannerMobileContext } from "../../../context/BannerMobileContext/BannerMobileContext";
import SwitchOptionComponent from "../../../components/SwitchComponent";
import SelectComponent from "../../../components/SelectComponent";

const BannerMobileInfo = ({ hasNavigation, onHasNavigationChange, isUpper, onUpperChange }: { hasNavigation?: boolean; onHasNavigationChange: (checked: boolean) => void; isUpper?: boolean; onUpperChange?: (checked: boolean) => void }) => {
	const { bannerMobileForm, bannerMobileDetail, setBannerMobileForm } = useBannerMobileContext();
	const [isActive, setIsActive] = useState<boolean | undefined>(bannerMobileDetail?.isActive);

	useEffect(() => {
		setIsActive(bannerMobileDetail?.isActive);
	}, [bannerMobileDetail?.isActive]);

	return (
		<>
			<Row gutter={20}>
				<Col span={10}>
					<SwitchOptionComponent
						key={"isActive"}
						title={"Aktiflik"}
						value={isActive}
						onChange={(checked) => {
							setIsActive(checked);
							setBannerMobileForm({ ...bannerMobileForm, isActive: checked });
						}}
					/>
				</Col>
				<Col span={10}>
					<SwitchOptionComponent
						key={"hasNavigation"}
						title={"Yönlendirme"}
						helperText={"Banner'a tıklandığında yönlendirme yapılmasını sağlar."}
						value={hasNavigation}
						onChange={(checked) => {
							onHasNavigationChange(checked);
						}}
					/>
				</Col>
			</Row >
			<Row gutter={20}>
				<Col span={10}>
					<SelectComponent
						title={"Banner Konumu"}
						placeholder={"Lütfen seçiniz"}
						isRequired
						value={isUpper ? "top" : "bottom"}
						onChange={(value) => onUpperChange?.(value === "top")}
						options={[
							{ label: "Sayfa Başı", value: "top" },
							{ label: "Sayfa Sonu", value: "bottom" },
						]}
					/>
				</Col>
			</Row>
		</>
	);
};

export default BannerMobileInfo;
